const DebugApis = {
    async setEnvName(env: string): Promise<boolean> {
        try {
            const res = await window.LinkService?.request('/api/main/v1/debug/switchEnvName', { env });
            return res.data as boolean;
        } catch (error) {
            return false;
        }
    },

    async setEnvV1(isProd: boolean): Promise<boolean> {
        try {
            const res = await window.LinkService?.request('/api/main/v1/debug/switchEnv', { isProd });
            return res.data as boolean;
        } catch (error) {
            return false;
        }
    },

    async handleSyncPlaying(isSyncPlaying: boolean): Promise<boolean> {
        try {
            const res = await window.LinkService?.request('/api/main/v1/debug/syncPlaying', { isSyncPlaying });
            return res.data as boolean;
        } catch (error) {
            return false;
        }
    },
    async handleRecordSave(isSave: boolean): Promise<boolean> {
        try {
            const res = await window.LinkService?.request('/api/main/v1/debug/recordSave', { isSave });
            return res.data as boolean;
        } catch (error) {
            return false;
        }
    },
    async openAppConsole(isOpen: boolean): Promise<boolean> {
        try {
            const res = await window.LinkService?.request('/api/main/v1/debug/openAppConsole', { isOpen });
            return res.data as boolean;
        } catch (error) {
            return false;
        }
    },
    async getEnv(): Promise<string> {
        try {
            const res = await window.LinkService?.request('/api/main/v1/debug/getEnvName', {});
            return res.data;
        } catch (error) {
            console.log('应用端是旧版本，请求getEnv');
            const res = await window.LinkService?.request('/api/main/v1/debug/getEnv', {});
            return res.data ? 'prod' : 'test';
        }
    },
    async getRecordSave(): Promise<boolean> {
        try {
            const res = await window.LinkService?.request('/api/main/v1/debug/getRecordSave');
            return res.data;
        } catch (error) {
            return false;
        }
    },
    async getSyncPlaying(): Promise<boolean> {
        try {
            const res = await window.LinkService?.request('/api/main/v1/debug/getSyncPlaying');
            return res.data;
        } catch (error) {
            return false;
        }
    },
    async exportLog(): Promise<boolean> {
        try {
            const res = await window.LinkService?.request('/api/main/v1/debug/exportLog');
            return res.data;
        } catch (error) {
            return false;
        }
    }
}

export default DebugApis;